// The '…' (More) row-action button + its menu: the Sales Orders gear pattern (same 'more' glyph IcoChip, same .so-fmenu popup, portal, one at a time) for tables that
// are not the Sales Orders list. items = [{ id, label, icon, ok, why, run }]: disabled with the reason, never hidden.
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { IcoLn, IcoInline } from '../shell/ActionIcons';
import '../pages/Sales/ordersList/salesOrders.css';

export default function RowMoreMenu({ items, label, head, testid = 'row-more' }) {
  const [anchor, setAnchor] = useState(null);
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current; if (!el || !anchor) return;
    const r = anchor.getBoundingClientRect(), w = el.offsetWidth;
    el.style.left = `${Math.max(8, Math.min(r.left, window.innerWidth - w - 8))}px`;
    const h = el.offsetHeight; let y = r.bottom + 4; if (y + h > window.innerHeight - 8) y = Math.max(8, r.top - h - 4);
    el.style.top = `${y}px`;
  });
  useEffect(() => {
    if (!anchor) return undefined;
    const key = (e) => { if (e.key === 'Escape') { anchor.focus(); setAnchor(null); } };
    const away = (e) => { if (ref.current && !ref.current.contains(e.target) && !anchor.contains(e.target)) setAnchor(null); };
    const close = () => setAnchor(null);
    document.addEventListener('keydown', key); document.addEventListener('mousedown', away); window.addEventListener('resize', close);
    return () => { document.removeEventListener('keydown', key); document.removeEventListener('mousedown', away); window.removeEventListener('resize', close); };
  }, [anchor]);
  return <span onClick={e => e.stopPropagation()}>
    <button type="button" className="tbl-ico-btn" aria-label={label} title={label} aria-haspopup="menu" aria-expanded={!!anchor} data-testid={testid} onClick={e => { const el = e.currentTarget; setAnchor(a => (a === el ? null : el)); }}><IcoLn name="more" /></button>
    {anchor && createPortal(
      // 47277 (item 3): the popup portals to document.body with .so-fmenu z-index 130 (the Sales Orders LIST). Inside a record drawer (--z-drawer 1201) that put the menu BEHIND the
      // drawer, so clicking "…" did nothing. Lift it to --z-pill (1202, above the drawer, below modals) so the menu shows in every surface, drawers included.
      <div ref={ref} className="so-fmenu on" role="menu" data-testid={`${testid}-pop`} style={{ zIndex: 'var(--z-pill)' }}>
        {head && <div className="mh">{head}</div>}
        {items.map(i => <button key={i.id} type="button" role="menuitem" disabled={!i.ok} aria-disabled={!i.ok} data-testid={`${testid}-${i.id}`} onClick={() => { setAnchor(null); i.run(); }}>
          <IcoInline name={i.icon} />{i.label}{!i.ok && i.why && <span className="mwhy">{i.why}</span>}</button>)}
      </div>, document.body)}
  </span>;
}
